import React from "react";
import StyledUnorderedList from "./UnorderedList.styled";

const ToolsList = () => (
    <StyledUnorderedList>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">MySql</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Oracle</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Microsoft Sql Server</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">TOAD</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">IntelliJ</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">XML Spy</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Postman</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Google Workspace</div>
                <div>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                    <span className="star fa-solid fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Tomcat</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Apache</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Git\GitHub</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Adobe Photoshop CC</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Adobe Premiere Pro CC</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Adobe Illustrator CC</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Adobe After Effects CC</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Webflow</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Taleo</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group">
            <div className="list-item">
                <div className="text">Workday</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
        <li className="list-item-group no-bottom-border">
            <div className="list-item">
                <div className="text">ITSM Service Now</div>
                <div>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-solid   fa-star"/>
                    <span className="star fa-regular fa-star"/>
                    <span className="star fa-regular fa-star"/>
                </div>
            </div>
        </li>
    </StyledUnorderedList>
);

export default ToolsList;